const _excluded = ["style"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { stylePropType } from '@adsk/alloy-react-theme';
import MultiControl from '../../layout/Control/MultiControl';
import Tokens from '../../layout/Control/Tokens';
const MultiDropdownTokenControlWrapped = (_ref, ref) => {
  let {
      style
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(MultiControl, _extends({
    ref: ref
  }, props, {
    style: [{
      maxHeight: '6.25em',
      overflow: 'hidden'
    }, style],
    renderItems: _ref2 => {
      let {
        selectedItems,
        getSelectedItemProps,
        removeSelectedItem,
        itemToString
      } = _ref2;
      return /*#__PURE__*/React.createElement(Tokens, {
        selectedItems: selectedItems,
        getSelectedItemProps: getSelectedItemProps,
        removeSelectedItem: removeSelectedItem,
        itemToString: itemToString
      });
    }
  }));
};
const MultiDropdownTokenControl = /*#__PURE__*/React.forwardRef(MultiDropdownTokenControlWrapped);
MultiDropdownTokenControl.displayName = 'MultiDropdownTokenControl';
MultiDropdownTokenControl.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Toggle disabled state */
  disabled: PropTypes.bool,
  /** Toggle loading state */
  isLoading: PropTypes.bool,
  /** Toggle error state */
  error: PropTypes.bool,
  /** Whether Dropdown menu is open */
  isOpen: PropTypes.bool.isRequired,
  /** Function to get props for the menu toggle button */
  getToggleButtonProps: PropTypes.func.isRequired,
  /** The content of te ControlContainer */
  children: PropTypes.any
};
export default MultiDropdownTokenControl;
//# sourceMappingURL=MultiDropdownTokenControl.js.map